import { styled } from "@mui/material/styles";

export const PageHeaderDiv = styled("div")`
  display: flex;
  flex-direction: column;
`;
